import React from "react";
import PropTypes from "prop-types";
import { SearchQueryParamsProvider } from "./SearchQueryParamsContext";
import useSearchQueryParams from "./useSearchQueryParams";

const SearchQueryParams = (props) => {
    const { addedSchema, removeExtraParams, ...otherProps } = props;
    const searchQueryParamas = useSearchQueryParams({ addedSchema, removeExtraParams });

    const bag = { ...searchQueryParamas };

    return <SearchQueryParamsProvider {...otherProps} value={bag} />;
};
SearchQueryParams.propTypes = {
    addedSchema: PropTypes.object,
};

export default SearchQueryParams;
